/**
 * Ryerson's own social-media and contact links, the default content of `./SocialMedia.tsx`.
 * `instagram` is kept here, but the bar renders no Instagram icon (it was removed from the bar).
 */
import { SocialMediaBarItems } from "./SocialMedia";

/** Ryerson's channel URLs and contact address; the same on every brand's build. */
export const SocialMediaContent: SocialMediaBarItems = {
	facebook: "https://www.facebook.com/ryersonmetals/?fref=nf",
	instagram: "https://www.instagram.com/ryersonmetals/?hl=en",
	linkedIn: "https://www.linkedin.com/company/ryerson?trk=top_nav_home",
	email: "mailto:contactus@ryerson.com",
	youtube: "https://www.youtube.com/channel/UCAjLhGiGaSBbTOwq52rZNAw",
};
